import { BaseProductAttributesValues } from '../classes/BaseProductAttributes';


export class Prices {
    attributes: PriceAttribute[];
    price: number;
    ipt: number;
    productid: number;
    vat: number;
    productName: string;
    constructor()
    {
        this.attributes = [];
        this.price = 0;
        this.productName = '';
    }
}


export class PriceAttribute {
    description: string;
    excluded: boolean;
    isHidden: boolean;
    belongsToProduct: string;
    productId: number;
    maximum: number;
    minimum: number;
    invalidAttribute: boolean;
    mutable: boolean;
    id: number;
    name: string;
    formValue: string;
    htmlType: string;
    value: string;
    isRequired: boolean;
    sortorder: number;
    type: string;
    dataType: string;
    isCommonAttribute: boolean;
    options: BaseProductAttributesValues[];
    selectedValue: string;
    bespokeAttribute: boolean;
    priceRelatedAttribute: boolean;
    readonly: boolean;
}


export class DiscountPrices {
    id: number;
    price!: number;
    originalPrice!: number;
    ipt!: number;
    originalIPT!: number;
}